import { defineMessages } from 'react-intl';

export default defineMessages({
    baDriverTitle: {
        id: 'quoteandbind.ba.views.ba-driver-details.Driver',
        defaultMessage: 'Driver',
    },
    baDriverTitleNumber: {
        id: 'quoteandbind.ba.views.ba-driver-details.Driver:',
        defaultMessage: 'Driver:',
    },
    baDriver: {
        id: 'quoteandbind.views.quote.ba.Personal Auto Driver',
        defaultMessage: 'Personal Auto Driver',
    },
    removeDriverTitle: {
        id: 'quoteandbind.ba.controllers.BADriverDetailsCtrl.Remove Driver?',
        defaultMessage: 'Remove Driver?',
    },
    removeDriverDescription: {
        id: 'quoteandbind.ba.drivers.remove-driver.message',
        defaultMessage: 'Are you sure you want to remove this driver from the list of drivers?',
    },
    baAddAnotherDriverTitle: {
        id: 'quoteandbind.ba.views.ba-driver-details.Add Another Driver?',
        defaultMessage: 'Add Another Driver?',
    },
    baAddDriverButtonText: {
        id: 'quoteandbind.ba.views.ba-driver-details.Add Driver',
        defaultMessage: 'Add Driver',
    },
    baAdd: {
        id: 'quoteandbind.ba.views.ba-driver-details.Add',
        defaultMessage: 'Add',
    }
});
